(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mch-credentials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mch-credential-marquee')) {
  customElements.define('mch-credential-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '';
      const button = this.querySelector('button');
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
      });
      this.addEventListener('shopify:block:select', () => {
        this.setAttribute('data-paused', '');
        button.setAttribute('aria-pressed', 'true');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mch-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mch-immersive-hero')) {
 customElements.define('mch-immersive-hero', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   const options = { signal: this.abort.signal };
   const videos = Array.from(this.querySelectorAll('video'));
   if (!videos.length) return;

   const mobile = matchMedia('(max-width: 749px)');
   const reduced = matchMedia('(prefers-reduced-motion: reduce)');

   const select = () => {
    videos.forEach(video => {
     video.pause();
     video.style.display = 'none';
     video.removeAttribute('data-visible');
    });

    this.active = mobile.matches
     ? this.querySelector('.mch-immersive-hero__mobile-video') || this.querySelector('.mch-immersive-hero__desktop-video')
     : this.querySelector('.mch-immersive-hero__desktop-video');

    if (!this.active) return;

    this.active.style.display = 'block';

    if (this.dataset.autoplay === 'true' && !reduced.matches) {
     this.active.play().catch(() => {});
    }
   };

   videos.forEach(video => {
    video.addEventListener('playing', () => { video.dataset.visible = 'true'; }, options);
    video.addEventListener('error', () => { video.removeAttribute('data-visible'); }, options);
   });

   mobile.addEventListener('change', select, options);
   reduced.addEventListener('change', select, options);
   select();
  }

  disconnectedCallback() {
   this.abort?.abort();
   this.querySelectorAll('video').forEach(video => video.pause());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mch-home-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mch-review-carousel')) customElements.define('mch-review-carousel', class extends HTMLElement {
 connectedCallback() {
  this.cleanup?.();
  const abort = new AbortController(), options = {signal:abort.signal};
  const track = this.querySelector('.mch-client-reviews__track'), controls = this.querySelector('.mch-client-reviews__controls');
  const arrows = Array.from(this.querySelectorAll('[data-step]')), toggle = this.querySelector('[data-toggle]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let timer, hover = false, focus = false, paused = false, dragging = false;
  const overflow = () => track.scrollWidth > track.clientWidth + 2;
  const stop = () => { clearInterval(timer); timer = null; };
  const move = (step, wrap = false) => {
   const card = track.querySelector('figure'); if (!card) return;
   const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
   track.scrollTo({left: wrap && end ? 0 : track.scrollLeft + step * (card.getBoundingClientRect().width + 24), behavior: reduced.matches ? 'instant' : 'smooth'});
  };
  const schedule = () => {
   stop();
   if (toggle) { toggle.hidden = reduced.matches || this.dataset.editor === 'true'; toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause; }
   if (this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' && overflow() && !reduced.matches && !hover && !focus && !paused && !dragging && !document.hidden) timer = setInterval(() => move(1,true), Number(this.dataset.interval) || 6000);
  };
  const update = () => { controls.hidden = !overflow(); arrows[0].disabled = track.scrollLeft < 2; arrows[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
  arrows.forEach(button => button.addEventListener('click', () => { move(Number(button.dataset.step)); schedule(); },options));
  toggle?.addEventListener('click', () => { paused = !paused; schedule(); },options);
  this.addEventListener('mouseenter', () => { hover = true; schedule(); },options);
  this.addEventListener('mouseleave', () => { hover = false; schedule(); },options);
  this.addEventListener('focusin', () => { focus = true; schedule(); },options);
  this.addEventListener('focusout', event => { focus = this.contains(event.relatedTarget); schedule(); },options);
  track.addEventListener('pointerdown', () => { dragging = true; schedule(); },options);
  window.addEventListener('pointerup', () => { dragging = false; schedule(); },options);
  window.addEventListener('pointercancel', () => { dragging = false; schedule(); },options);
  track.addEventListener('scroll', update, {signal:abort.signal,passive:true});
  reduced.addEventListener('change', schedule,options);
  document.addEventListener('visibilitychange',schedule,options);
  this.addEventListener('shopify:block:select', event => { const card = event.target.closest('figure'); if(card) { paused = true; schedule(); track.scrollBy({left:card.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:'instant'}); } },options);
  const resize = new ResizeObserver(() => { update(); schedule(); }); resize.observe(track);
  const mutation = new MutationObserver(() => { update(); schedule(); }); mutation.observe(track,{childList:true});
  this.cleanup = () => { stop(); abort.abort(); resize.disconnect(); mutation.disconnect(); };
  update(); schedule();
 }
 disconnectedCallback() { this.cleanup?.(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mch-home-transformations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mch-transformations-marquee')) {
  customElements.define('mch-transformations-marquee', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mch-transformations__track');
      this.group = this.querySelector('.mch-transformations__group');
      if (!this.track || !this.group) return;

      this.updateSpeed = () => {
        const speedSetting = Math.max(1, Math.min(10, Number(this.dataset.speed) || 5));
        const pixelsPerSecond = 32 + (speedSetting * 10);
        const distance = this.group.getBoundingClientRect().width;
        const duration = Math.max(12, distance / pixelsPerSecond);
        this.style.setProperty('--mch-transformations-duration', duration + 's');
      };

      this.resizeObserver = new ResizeObserver(this.updateSpeed);
      this.resizeObserver.observe(this.group);
      this.updateSpeed();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mch-services"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mch-service-tabs')) {
  customElements.define('mch-service-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.tabsInitialized) return;
      this.tabsInitialized = true;
      const list = this.querySelector('.mch-service-tabs');
      const tabs = Array.from(list.querySelectorAll('a'));
      const panels = tabs.map(tab => this.querySelector(tab.getAttribute('href')));
      if (!tabs.length || panels.some(panel => !panel)) return;
      list.setAttribute('role', 'tablist');
      const photos = Array.from(this.querySelectorAll('[data-service-photo]'));
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        photos.forEach(photo => { photo.hidden = photo.dataset.servicePhoto !== panels[index].id; });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); select(i); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') next = i;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('.mch-service-category');
        const service = event.target.closest('.mch-service-entry');
        let index = panels.indexOf(panel);

        if (service && service.dataset.serviceCategory) {
          const categoryPanel = panels.find(candidate => {
            const tab = tabs[panels.indexOf(candidate)];
            return tab && tab.textContent.trim().toLowerCase().replace(/\s*\+\s*/g, '-').replace(/\s+/g, '-') === service.dataset.serviceCategory;
          });
          const categoryIndex = panels.indexOf(categoryPanel);
          if (categoryIndex !== -1) index = categoryIndex;
        }

        if (index !== -1) select(index);
      });
      const hashIndex = tabs.findIndex(tab => tab.hash === window.location.hash);
      select(hashIndex < 0 ? 0 : hashIndex);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
